import React from 'react';
import {
  H3,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../core';
import { PatientDetails, formatPatientName } from '../../../api/models';

interface PatientProps {
  patientDetails?: PatientDetails;
}

const Patient: React.FC<PatientProps> = (props: PatientProps) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <H3 text="PATIENT" />
      <Paragraph text={formatPatientName(props.patientDetails?.demographics)} />
    </StackedColumn>
  );
};

export default Patient;
